export const linkResolver = (doc) => {
  if (!doc || !doc.type) return '/';

  switch (doc.type) {
    case 'article':
      return `/article/${doc.uid}`;
    case 'contrast_checker_page':
      return '/contrast-checker/';
    case 'work_page':
      return '/work/';
    case 'capabilities':
      return '/capabilities/';
    case 'contact_us_page':
      return '/contact-us/';
    case 'case_study':
      return `/case-study/${doc.uid}`;
    case 'industry':
      return `/industry/${doc.uid}`;
    case 'home_page':
      return '/';
    default:
      return `/doc/${doc.id}`;
  }
};